






































import CTextArea from '~/components/shared/configurable/form/input/CTextArea.vue'
import { defineComponent, vue3Model } from '~/utils/nuxt3-migration'

function getDefaultForm() {
  return {
    reason: '',
    notes: null
  }
}

export default defineComponent({
  components: {
    CTextArea
  },
  model: vue3Model,
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    reasons: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    form: getDefaultForm()
  }),
  computed: {
    visible: {
      get() {
        return this.modelValue
      },
      set(value: boolean) {
        this.$emit('update:modelValue', value)
      }
    }
  },
  methods: {
    handleOk() {
      this.$emit('ok', {
        reason: this.form.reason,
        notes: this.form.notes
      })
    },
    handleCancel() {
      this.form = getDefaultForm()
      this.$emit('cancel')
    },
    showModal() {
      this.visible = true
    }
  }
})
